import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AbilityService } from 'ability';
import { Observable, of } from 'rxjs';

@Injectable()
export class StatisticsGuard implements CanActivate {
  private ability = inject(AbilityService);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return of(this.ability.can('read', 'Provider'));
  }
}
